import React, { useEffect, useState } from "react";
import { Main, Content } from '../../../components/Layout'
import api from '../../../services/api';
import { ChartsBar } from "../../../components/Charts";
import { Col, Row, Table, Form } from 'react-bootstrap';
import DatePicker from '../../../components/DatePicker';
import Slct from '../../../components/Slct'
import getCommercial from "../../../util/getCommercial";
import { PrintPage } from "../../../components/PrintPage";
import Loading from "../../../components/Loading";
import { IntegerNumber } from "../../../components/Input";
import TableResponsive from "../../../components/TableResponsive";
import IcSetaDown from "../../../components/Svg/IcSetaDown";
import StatusFlag from "../../../components/StatusFlag";
import IcX from "../../../components/Svg/IcX";
import { formatReal } from "../../../util/functions";
import useWrapper from "../../../hooks/useWrapper";

export default function ReportsBusiness() {
  const { setbreadcrumb, config, me } = useWrapper();

  const filterInit = {
    "Tipo": { label: "Status", value: "status" },
    "Data Inicial": null,
    "Data Final": null,
  }
  const [filter, setFilter] = useState(filterInit)
  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: ""
  });

  const [filterLoading, setfilterLoading] = useState(true);

  const [institutions, setinstitutions] = useState();
  const [courses, setcourses] = useState();
  useEffect(() => {
    const PARAMS = new URLSearchParams({
      ...((filter["Data Inicial"] || filter["Data Final"]) && {
        createInterval: `${filter["Data Inicial"] ? filter["Data Inicial"].toJSON() : null}|${filter["Data Final"] ? filter["Data Final"].toJSON() : null}`
      }),
      ...((filter["Tipo"].value === "cancelamento" && filter["Motivo do Cancelamento"]?.value !== "") && {
        reason: filter["Motivo do Cancelamento"]?.value
      })
    });
    setfilterLoading(true);
    switch (filter["Tipo"].value) {
      case "cursos":
        api.get(`/course/report?report=true&commercials.is_class=0&${PARAMS}`, config)
          .then(response => {
            let responseVar = [...response.data];
            responseVar = responseVar.map(__institution => ({
              ...__institution,
              commercials: __institution.commercials.filter(__commercial => (!__commercial.is_class && !!__commercial.step_id))
            }))
            responseVar.sort(function (a, b) {
              return a.commercials.length < b.commercials.length;
            })

            let tableVar = [];
            responseVar.forEach((e, index) => {
              e.commercials.filter(e => !!e.step_id).forEach(r => {
                tableVar.push({
                  label: `${e.title} ${r.year}.${r.period} (${r.institution ? r.institution.title : ''})`,
                  type: e.id,
                  color: index + 1,
                  is_class: r.is_class,
                  course: e.title
                })
              })
            })

            setReports({
              data: responseVar.map(e => ({
                label: e.title,
                value: e.commercials.length
              })),
              title: "Turmas por curso",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "instituicoes":
        api.get("/institution/report?commercials.is_class=0", config)
          .then(response => {
            let responseVar = [...response.data];
            responseVar = responseVar.map(__institution => ({
              ...__institution,
              commercials: __institution.commercials.filter(__commercial => (!__commercial.is_class && !!__commercial.step_id))
            }))
            responseVar.sort(function (a, b) {
              return a.__meta__.total_commercials < b.__meta__.total_commercials;
            })

            let tableVar = [];
            responseVar.forEach((e, index) => {
              e.commercials.forEach(r => {
                tableVar.push({
                  label: `${r.course.title} ${r.year}.${r.period} (${r.institution ? r.institution.title : ''})`,
                  type: e.id,
                  color: index + 1,
                  is_class: r.is_class,
                  step_id: r.step_id,
                  institution: r.institution?.title
                })
              })
            })

            setReports({
              data: responseVar.map(e => ({
                label: e.title,
                value: e.commercials.filter(__commercial => !__commercial.is_class).length
              })),
              title: "Turmas por instituição",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "periodo":
        api.get(`/commercial/period/report?is_class=0&${PARAMS}`, config)
          .then(response => {
            let responseVar = [...response.data.data].filter(e => !!e.step_id);
            responseVar.sort(function (a, b) {
              return a.period > b.period;
            })

            let tableVar = responseVar.map(e => ({
              label: `${e.course.title} ${e.year}.${e.period} (${e.institution ? e.institution.title : ''})`,
              type: e.period,
              color: e.period,
              is_class: e.is_class
            }))

            setReports({
              data: [
                { label: "Primeiro Período", value: responseVar.filter(__course => Number(__course?.period) === 1)?.length },
                { label: "Segundo Período", value: responseVar.filter(__course => Number(__course?.period) === 2)?.length }
              ],
              title: "Turmas por período",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
      case "cancelamento":
        getCommercial(null, null, `?status=trade-canceled&${PARAMS}`, "", true)
          .then(resp => {
            let _data = [];
            let _table = [];
            let _color = 0;

            if (!filter["Motivo do Cancelamento"]?.value) {
              resp.forEach(e => {
                let _type = _data.find((e2, i2) => {
                  if (e2.label === e.cancel_reason) {
                    _color = i2 + 1;
                    return e2;
                  }
                  else {
                    _color = _data.length + 1;
                    return false;
                  }
                })
                if (!_type) {
                  _data.push({
                    label: e.cancel_reason,
                    value: resp.filter(e2 => e2.cancel_reason === e.cancel_reason).length
                  })
                }

                _table.push({
                  label: e.label,
                  type: e.cancel_reason,
                  color: _color,
                  ...(e.competitor ? { competitor: e.competitor.name } : { competitor: "" }),
                  cancel_obs: e.cancel_obs,
                  ...(e.cancel_reason === "outro" ? {
                    cancel_reason_obs: e.cancel_reason_obs
                  } : { cancel_reason_obs: "" })
                })
              })
              _data = _data.map(el => ({
                ...el,
                label: el.label === "concorrencia" ? "Concorrência" : "Outros Motivos"
              }))
            }
            else if ((filter["Motivo do Cancelamento"]?.value === "concorrencia")) {
              resp.forEach(e => {
                let _type = _data.find((e2, i2) => {
                  if (e2.label === e.competitor.name) {
                    _color = i2 + 1;
                    return e2;
                  }
                  else {
                    _color = _data.length + 1;
                    return false;
                  }
                })
                if (!_type) {
                  _data.push({
                    label: e.competitor.name,
                    value: resp.filter(e2 => e2.competitor.name === e.competitor.name).length
                  })
                }
                _table.push({
                  label: e.label,
                  type: e.competitor.name,
                  color: _color,
                  // competitor: e.competitor.name,
                  cancel_obs: e.cancel_obs,
                  ...(e.cancel_reason === "outro" && {
                    cancel_reason_obs: e.cancel_reason_obs
                  })
                })
              })
            }
            setReports({
              data: _data,
              title: "Tipos de Cancelamentos",
              type: "cancelamentos",
              table: _table
            })
            setfilterLoading(false);
          })
        break;
      case "vendedores":
        api.get('users', config)
          .then(_users => {
            api.get("/commercial/total-amount/report", config)
              .then(_commercials => {
                let __commercials = [..._commercials.data];
                if (filter["Visualização"]?.value === "propostas") {
                  __commercials = __commercials.filter(__commercial => __commercial.is_class === 0)
                }
                else if (filter["Visualização"]?.value === "turmas") {
                  __commercials = __commercials.filter(__commercial => __commercial.is_class === 1)
                }
                else if (filter["Visualização"]?.value === "conversoes") {

                }
                _users = _users.data.data.map(__user => ({
                  ...__user,
                  commercials: __commercials.filter(__commercial => __commercial.user_id === __user.id) || []
                }))

                _users.sort(function (a, b) {
                  return a.username > b.username;
                })

                let _table = [];
                _users.forEach((__user, i) => {
                  __user.commercials.forEach(__commercial => {
                    _table.push({
                      label: `${__commercial.course?.title} ${__commercial.year}.${__commercial.period} (${__commercial.institution?.title})`,
                      type: __user.username,
                      color: i + 1,
                      status: `${__commercial.is_class ? "Turma" : "Proposta"} ${__commercial.status === "active" ? "Ativa" : "Cancelada"}`,
                      trainee_expectation: __commercial.total_trainees,
                      trainee_signeds: __commercial.trainee?.length,
                      collect: __commercial.aReceber,
                      expetation: __commercial.totalRecebido

                    })
                  })
                })

                let _data = _users.map(__user => ({
                  label: __user.username,
                  value: __user.commercials.length
                }))
                setReports({
                  data: _data,
                  title: "Vendedores",
                  type: "vendedores",
                  table: _table
                })
                setfilterLoading(false);
              })
          })
        break;
      case "lacunas":
        if (filter["Ano Inicial"] && filter["Ano Final"]) {
          if (String(filter["Ano Inicial"]).length === 4 && String(filter["Ano Final"]).length === 4) {
            (async function () {
              const _commercial = await getCommercial(null, null, "?", "", true);
              const _institutions = await api.get('institutions', config);

              setinstitutions([{
                label: "-- Todas --",
                value: null
              }].concat(_institutions.data.data.map(__institution => ({
                label: __institution.title,
                value: __institution.id
              }))))

              const year = {
                start: filter["Ano Inicial"],
                end: filter["Ano Final"]
              }

              let _all_institutions_courses = [];
              _institutions.data.data.forEach(__institution => {
                __institution.courses
                  .filter(__course => __course?.id === filter["Curso"]?.value || !filter["Curso"]?.value)
                  .forEach(__course => {
                    for (let __year = year.start; __year <= year.end; __year++) {
                      for (let __period = 1; __period <= 2; __period++) {
                        const _commercial = __institution.commercials.find(__commercial => Number(__commercial.year) === __year && Number(__commercial.period) === __period);

                        let _commercial_status;
                        if (!_commercial) {
                          _commercial_status = "Lacuna";
                        }
                        else if (_commercial?.is_class) {
                          _commercial_status = "Fechado";
                        }
                        else if (_commercial?.status === "active") {
                          _commercial_status = "Em Negociação";
                        }
                        else {
                          _commercial_status = "Perdido";
                        }



                        _all_institutions_courses.push({
                          course: {
                            id: __course.id,
                            name: __course.title
                          },
                          institution: {
                            id: __institution.id,
                            name: __institution.title
                          },
                          year: __year,
                          period: __period,
                          commercial_status: _commercial_status // "Lacuna", "Em Negociação", "Fechado", "Perdido"
                        })
                      }
                    }
                  })
              })

              let _all_courses = _all_institutions_courses.map(__inst_course => ({
                label: __inst_course.course.name,
                value: __inst_course.course.id
              }));

              _all_courses = _all_courses.filter((value, index, self) =>
                index === self.findIndex((t) => (
                  t.value === value.value
                ))
              )
              !courses && setcourses(_all_courses);

              if (filter["Instituição"]?.value) {
                _all_institutions_courses = _all_institutions_courses.filter(__institution_course => __institution_course.institution.id === filter["Instituição"].value);
              }

              if (filter["Status"]?.value) {
                _all_institutions_courses = _all_institutions_courses.filter(__institution_course => __institution_course.commercial_status === filter["Status"].value);
              }

              let _status = [
                { label: "Lacuna", value: _all_institutions_courses.filter(__group => __group.commercial_status === "Lacuna")?.length },
                { label: "Fechado", value: _all_institutions_courses.filter(__group => __group.commercial_status === "Fechado")?.length },
                { label: "Em Negociação", value: _all_institutions_courses.filter(__group => __group.commercial_status === "Em Negociação")?.length },
                { label: "Perdido", value: _all_institutions_courses.filter(__group => __group.commercial_status === "Perdido")?.length },
              ]

              let _table = _all_institutions_courses.map(_group => ({
                label: `${_group.course.name} ${_group.year}.${_group.period} (${_group.institution.name})`,
                type: _group.commercial_status,
                color: _status.map(__status => __status.label).indexOf(_group.commercial_status) + 1
              }))

              setReports({
                data: _status,
                title: "Lacuna de Turmas",
                type: "lacunas",
                table: _table
              })
              setfilterLoading(false);
            })()
          }
        }
        break;
      case "status":
      default:
        api.get(`/commercial/step/report?${PARAMS}`, config)
          .then(response => {
            let _status = [
              { label: "Primeiro Contato", value: response.data.primeiroContato },
              { label: "Orçamento", value: response.data.orcamento },
              { label: "Envio de Proposta", value: response.data.envioProposta },
              { label: "Fechamento", value: response.data.fechamento }
            ]
            let responseVar = [...response.data.data];

            responseVar = responseVar.map(e => {
              if (e.is_class) {
                return ({
                  ...e,
                  step_id: 5
                })
              } else {
                return e
              }
            })
            responseVar.sort(function (a, b) {
              return a.step_id > b.step_id;
            })
            let tableVar = responseVar.map(e => ({
              label: `${e.course.title} ${e.year}.${e.period} (${e.institution ? e.institution.title : ''})`,
              type: _status[e.step_id - 1].label,
              color: e.step_id,
              is_class: e.is_class
            }))
            setReports({
              data: _status,
              title: "Turmas por status",
              type: "turmas",
              table: tableVar
            })
            setfilterLoading(false);
          })
        break;
    }
  }, [filter])

  useEffect(() => {
    setbreadcrumb([
      { label: "Relatórios" },
    ])
  }, []);

  return (
    <PrintPage
      has_logo={true}
      signed_by={me.username}
    >
      <Main>
        <Content id="pdf">
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios do Comercial</h2>
                <div className="d-flex ml-4">
                  <PrintPage.PrintButton
                    label="Gerar PDF"
                  />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports.title}
                    overview={reports.data}
                    table={reports?.table?.map(_row => ({
                      ...(_row.label !== undefined && { "Turma": _row.label }),
                      ...(_row.type !== undefined && { "": _row.type }),
                      ...(_row.competitor !== undefined && { "Concorrente": _row.competitor }),
                      ...(_row.cancel_obs !== undefined && { "Motivo": _row.cancel_obs }),
                      ...(_row.label !== undefined && { "Turma": _row.label }),
                      ...((_row.collect !== undefined || _row.expetation !== undefined) && { "Receita (Expectativa)": `${_row.expetation}` }),
                      ...((_row.collect !== undefined || _row.expetation !== undefined) && { "Receita (Coletado)": `${_row.collect}` }),
                      ...((_row.trainee_signeds !== undefined || _row.trainee_expectation !== undefined) && { "Cadastros (Expectativa)": `${_row.trainee_expectation}` }),
                      ...((_row.trainee_signeds !== undefined || _row.trainee_expectation !== undefined) && { "Cadastros (Real)": `${_row.trainee_signeds}` })
                    }))}
                    signed_by={me.username}
                    filter={filter}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
            <Col sm={3}>
              <Form.Group>
                <span className='lince-input_label'>Tipo de Resultados</span>
                <Slct
                  className="w-100"
                  placeholder="..."
                  value={filter["Tipo"]?.value}
                  options={[
                    { label: "Status", value: "status" },
                    { label: "Instituições", value: "instituicoes" },
                    { label: "Cursos", value: "cursos" },
                    { label: "Período", value: "periodo" },
                    { label: "Turmas Perdidas", value: "cancelamento" },
                    { label: "Vendedores", value: "vendedores" },
                    { label: "Lacunas", value: "lacunas" },
                  ]}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      "Tipo": e,
                      ...(e.value === "cancelamento" && { "Motivo do Cancelamento": { label: "Visão Geral", value: "" } }),
                      ...(e.value === "vendedores" && { "Visualização": { label: "Visão Geral", value: "" } }),
                      ...(e.value === "lacunas" && {
                        "Ano Inicial": new Date().getFullYear() - 1,
                        "Ano Final": new Date().getFullYear() + 1
                      })
                    })
                  }}
                />
              </Form.Group>
            </Col>
            {reports.type === "cancelamentos" && (
              <Col sm={3} className="-hide-on-print">
                <Form.Group>
                  <span className='lince-input_label'>Motivo do Cancelamento</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Motivo do Cancelamento"]?.value}
                    options={[
                      { label: "Visão Geral", value: "" },
                      { label: "Concorrência", value: "concorrencia" }
                    ]}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        "Motivo do Cancelamento": e,
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            )}
            {reports.type === 'vendedores' && (
              <Col sm={3}>
                <Form.Group>
                  <span className='lince-input_label'>Visualização</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Visualização"]?.value}
                    options={[
                      { label: "Visão Geral", value: "" },
                      { label: "Propostas Ativas", value: "propostas" },
                      { label: "Contratos Fechados", value: "turmas" },
                      { label: "Conversões", value: "conversoes" }
                    ]}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        "Visualização": e
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            )}
            {(filter["Tipo"].value !== 'cursos' && filter["Tipo"].value !== 'lacunas') && (
              <>
                <Col sm={3}>
                  <Form.Group>
                    <span className='lince-input_label'>Data Inicial</span>
                    <DatePicker
                      canClear
                      selected={filter["Data Inicial"]}
                      changeDate={e => {
                        setFilter({
                          ...filter,
                          "Data Inicial": e
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group>
                    <span className='lince-input_label'>Data Final</span>
                    <DatePicker
                      canClear
                      selected={filter["Data Final"]}
                      changeDate={e => {
                        setFilter({
                          ...filter,
                          "Data Final": e
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            {filter["Tipo"].value === 'lacunas' && (
              <>
                <Col sm={3}>
                  <Form.Group>
                    <span className='lince-input_label'>Ano Inicial</span>
                    <IntegerNumber
                      value={filter["Ano Inicial"]}
                      valueChange={ev => {
                        setFilter({
                          ...filter,
                          "Ano Inicial": ev || ""
                        })
                      }}
                      maxlength="4"
                    />
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group>
                    <span className='lince-input_label'>Ano Final</span>
                    <IntegerNumber
                      value={filter["Ano Final"]}
                      valueChange={ev => {
                        setFilter({
                          ...filter,
                          "Ano Final": ev || ""
                        })
                      }}
                      maxlength="4"
                    />
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group>
                    <span className='lince-input_label'>Instituição</span>
                    <Slct
                      className="w-100"
                      placeholder="..."
                      value={filter["Instituição"]?.value}
                      options={institutions || []}
                      onChange={e => {
                        setFilter({
                          ...filter,
                          "Instituição": e
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={3} className="mt-2">
                  <Form.Group>
                    <span className='lince-input_label'>Status</span>
                    <Slct
                      className="w-100"
                      placeholder="..."
                      value={filter["Status"]?.value}
                      options={[
                        { label: "-- Todos --", value: null },
                        { label: "Lacuna", value: "Lacuna" },
                        { label: "Fechado", value: "Fechado" },
                        { label: "Em Negociação", value: "Em Negociação" },
                        { label: "Perdido", value: "Perdido" }
                      ]}
                      onChange={e => {
                        setFilter({
                          ...filter,
                          "Status": e
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={3} className="mt-2">
                  <span className='lince-input_label'>Curso</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Curso"]?.value}
                    options={[{ value: null, label: "-- Todos --" }].concat(courses || []) || []}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        "Curso": e
                      })
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
          {JSON.stringify(filter) !== JSON.stringify(filterInit) && (
            <Row className="mt-4">
              <Col>
                <button onClick={() => {
                  setFilter(filterInit);
                }} className={`clear-search`}>
                  <span>
                    <span><IcX /></span>
                    <span>Limpar busca</span>
                  </span>
                </button>
              </Col>
            </Row>
          )}
          {filterLoading ? (
            <Loading className="mt-3" />
          ) : (
            <Row>
              <Col>
                <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
                {reports.table && (

                  // value={filter["Tipo"]?.value}
                  // options={[
                  //   { label: "Status", value: "status" },
                  //   { label: "Instituições", value: "instituicoes" },
                  //   { label: "Cursos", value: "cursos" },
                  //   { label: "Período", value: "periodo" },
                  //   { label: "Turmas Perdidas", value: "cancelamento" },
                  //   { label: "Vendedores", value: "vendedores" },
                  //   { label: "Lacunas", value: "lacunas" },
                  <TableResponsive
                    className="mt-3"
                    table={{
                      head: [
                        ...(filter["Tipo"]?.value === "cancelamento" ? [
                          { data: "Turma" },
                          { data: "Concorrente" },
                          { data: "" },
                          { data: "" },
                        ] : []),
                        ...(filter["Tipo"]?.value === "cursos" ? [
                          { data: "Turma" },
                          { data: "" }
                        ] : []),
                        ...(filter["Tipo"]?.value === "instituicoes" ? [
                          { data: "Turma" },
                          { data: "" }
                        ] : []),
                        ...(filter["Tipo"]?.value === "lacunas" ? [
                          { data: "Turma" },
                          { data: "" }
                        ] : []),
                        ...(filter["Tipo"]?.value === "periodo" ? [
                          { data: "Turma" },
                          { data: "" }
                        ] : []),
                        ...(filter["Tipo"]?.value === "status" ? [
                          { data: "Turma" },
                          { data: "" }
                        ] : []),
                        ...(filter["Tipo"]?.value === "vendedores" ? [
                          { data: "Turma" },
                          { data: "Vendedor" },
                          {
                            data: "Receita",
                            sub: [
                              { data: "Real" },
                              { data: "Expectativa" },

                            ]
                          },
                          {
                            data: "Cadastros",
                            sub: [
                              { data: "Real" },
                              { data: "Expectativa" },

                            ]
                          },
                          { data: "Status" }
                        ] : []),
                      ],
                      body: reports?.table.map(__row => ({
                        data: [
                          ...(filter["Tipo"]?.value === "cancelamento" ? [
                            { element: __row.label },
                            { element: __row.competitor },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  {!filter["Motivo do Cancelamento"]?.value !== "concorrencia" ? (
                                    <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.type === "outro" ? "Outros Motivos" : "Concorrência"} />
                                  ) : (
                                    <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.competitor} />
                                  )}
                                </div>
                              )
                            },
                            {
                              ...((__row.cancel_obs || __row.cancel_reason_obs) ? {
                                element: <span className="simple-ico" style={{ cursor: "pointer", textAlign: "right", display: "block" }}><IcSetaDown /></span>,
                                id: "cancel_obs",
                                spoiler: (
                                  <>
                                    {!!__row.competitor && (
                                      <>
                                        <p><b>Razão do Cancelamento:</b></p>
                                        <p>Concorrência ({__row.competitor})</p>
                                      </>
                                    )}
                                    {!!__row.cancel_reason_obs && (
                                      <>
                                        <p><b>Razão do Cancelamento:</b></p>
                                        <p>{__row.cancel_reason_obs}</p>
                                      </>
                                    )}
                                    {!!__row.cancel_obs && (
                                      <>
                                        <p><b>Observação:</b></p>
                                        <p>{__row.cancel_obs}</p>
                                      </>
                                    )}
                                  </>
                                )
                              } : {
                                element: <></>
                              })
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "cursos" ? [
                            { element: __row.label },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.course} />
                                </div>
                              )
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "instituicoes" ? [
                            { element: __row.label },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.institution} />
                                </div>
                              )
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "lacunas" ? [
                            { element: __row.label },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.type} />
                                </div>
                              )
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "periodo" ? [
                            { element: __row.label },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={`${__row.type}ᵒ Período`} />
                                </div>
                              )
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "status" ? [
                            { element: __row.label },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.type} />
                                </div>
                              )
                            }
                          ] : []),
                          ...(filter["Tipo"]?.value === "vendedores" ? [
                            { element: __row.label },
                            {
                              element: <StatusFlag style={{ backgroundColor: `var(--color-cycle-${__row.color})` }} status={__row.type} />

                            },
                            { element: formatReal(__row.collect) },
                            { element: formatReal(__row.expetation) },
                            { element: __row.trainee_signeds },
                            { element: __row.trainee_expectation },
                            { element: __row.status }
                          ] : []),
                        ],
                        border: `var(--color-cycle-${__row.color})`
                      }))
                    }}
                  />
                  // <Table className={`${tableStyle.table} mt-4`}>
                  //   <thead>
                  //     <tr>
                  //       <th>Turma</th>
                  //       {reports.type === "cancelamentos" && (
                  //         <>
                  //           <th>Concorrente</th>
                  //           <th className="-hide-on-print">Informações</th>
                  //         </>
                  //       )}
                  //       {reports.type === "vendedores" && (
                  //         <>
                  //           <th>Vendedor</th>
                  //           <th colSpan={2} className="text-center">Receita</th>
                  //           <th colSpan={2} className="text-center">Cadastros</th>
                  //           <th>Status</th>
                  //         </>
                  //       )}
                  //       {reports.type === "lacunas" && (
                  //         <>
                  //           <th>Status</th>
                  //         </>
                  //       )}
                  //     </tr>
                  //   </thead>
                  //   <tbody>
                  //     {reports.type === "vendedores" && (
                  //       <tr className={`${tableStyle.sub_h} mt-4`}>
                  //         <td colSpan={2}></td>
                  //         <td><span>Real</span></td>
                  //         <td><span>Expectativa</span></td>
                  //         <td><span>Real</span></td>
                  //         <td><span>Expectativa</span></td>
                  //         <td></td>
                  //       </tr>
                  //     )}

                  //     {reports.table.map(e => (
                  //       <>
                  //         <tr>
                  //           <td>
                  //             <span className="small-circle mr-2" style={{ background: `var(--color-cycle-${e.color})` }}></span>
                  //             {e.label}
                  //           </td>
                  //           {reports.type === "lacunas" && (
                  //             <>
                  //               <td>{e.type}</td>
                  //             </>
                  //           )}
                  //           {reports.type === "vendedores" && (
                  //             <>
                  //               <td>{e.type}</td>
                  //               <td className="text-center">{`R$ ${e.expetation?.toFixed(2) || "0.00"}`}</td>
                  //               <td className="text-center">{`R$ ${e.collect?.toFixed(2) || "0.00"}`}</td>
                  //               <td className="text-center">{`${e.trainee_expectation}`}</td>
                  //               <td className="text-center">{`${e.trainee_signeds}`}</td>
                  //               <td>{e.status}</td>
                  //             </>
                  //           )}
                  //           {reports.type === "cancelamentos" && (
                  //             <>
                  //               <td>
                  //                 {filter["Motivo do Cancelamento"].value === "concorrencia" ? e.type || "-" : e.competitor || "-"}
                  //               </td>
                  //               <td
                  //                 className="-hide-on-print"
                  //                 onClick={e => {
                  //                   let parent = e.target.closest('tr')
                  //                   viewInfos = !viewInfos;
                  //                   parent.classList = ''
                  //                   parent.classList.add(viewInfos ? 'show_desc' : 'hide_desc')
                  //                 }
                  //                 }>
                  //                 <button className={`${tableStyle.seeTable}`}>
                  //                   Ver <IcDown />
                  //                 </button>
                  //               </td>
                  //             </>
                  //           )}
                  //         </tr>
                  //         {reports.type === "cancelamentos" && (
                  //           <tr className={`${tableStyle.descricaoTable} ${viewInfos ? 'show' : 'hide'}`}>
                  //             <td td colSpan="8" className="vermaisDescricao">
                  //               {!!e.cancel_reason_obs && (
                  //                 <p><b>Razão:</b> {e.cancel_reason_obs}</p>
                  //               )}
                  //               <p><b>Obs:</b> {e.cancel_obs}</p>
                  //             </td>
                  //           </tr>
                  //         )}
                  //       </>
                  //     ))}
                  //   </tbody>
                  // </Table>
                )}
              </Col>
            </Row>
          )}
        </Content>
      </Main>
    </PrintPage>
  );
}